import "./App.css";
import ImageForm from "./components/ImageForm";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ViewAedes from "./pages/ViewAede";
import Profile from "./pages/Profile";
import ViewTable from "./pages/ViewTable";
import { Error } from "./components/Error";
import { Loading } from "./components/Loading";
import { useAuth0 } from "@auth0/auth0-react";
import YoloAdd from "./pages/YoloAdd";
import YoloImageNoSubmit from "./components/YoloNoSubmit";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { MobileCamera } from "./pages/MobileCamera";
import Welcome from "./pages/Welcome";
import AuthenticationGuard from "./components/authentication-guard";
import EditAede from "./pages/EditAede";
import YoloCloudAdd from "./pages/YoloCloudAdd";
import ButtonAppBar from "./components/ButtonAppBar";
import AnnouncementBanner from "./components/AnnouncementBanner";
import Footer from "./components/Footer";
import Support from "./pages/Support";
import Download from "./pages/Download";
import BreadCrumbs from "./components/BreadCrumbs";
import Groups from "./pages/Groups";
import GroupDetail from "./pages/GroupDetail";
import Collections from "./pages/Collections";
import CollectionDetail from "./pages/CollectionDetail";
import MyInvites from "./pages/MyInvites";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUserDetail from "./pages/AdminUserDetail";
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setupAxiosInterceptors } from "./utils/axiosInterceptor";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const {
    isLoading,
    getAccessTokenSilently,
    logout,
  } = useAuth0();

  useEffect(() => {
    setupAxiosInterceptors(
      () => getAccessTokenSilently({
        authorizationParams: {
          audience: "https://api.acttstudy.org/",
        },
      }),
      () => logout({
        logoutParams: {
          returnTo: window.location.origin + '/welcome',
        },
      })
    );
  }, [getAccessTokenSilently, logout]);

  if (isLoading) {
    return <Loading />;
  }
  return (
    <QueryClientProvider client={queryClient}>
      <ButtonAppBar />
      <AnnouncementBanner />
      <BreadCrumbs />
      <Routes>
        <Route
          path="/cam"
          element={<AuthenticationGuard component={MobileCamera} />}
        />
        <Route path="/welcome" element={<Welcome />} />
        <Route
          path="/add"
          element={<AuthenticationGuard component={ImageForm} />}
        />
        <Route
          path="/images"
          element={<AuthenticationGuard component={ViewTable} />}
        />
        <Route
          path="/image/:id"
          element={<AuthenticationGuard component={ViewAedes} />}
        />
        <Route
          path="/edit/:id"
          element={<AuthenticationGuard component={EditAede} />}
        />
        <Route
          path="/profile"
          element={<AuthenticationGuard component={Profile} />}
        />
        <Route
          path="/yolo"
          element={<AuthenticationGuard component={YoloAdd} />}
        />
        <Route
          path="/yolocloud"
          element={<AuthenticationGuard component={YoloCloudAdd} />}
        />
        <Route path="/playground" element={<YoloImageNoSubmit />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/" element={<Home />} />
        <Route path="/support" element={<Support />} />
        <Route path="/download" element={<Download />} />
        <Route
          path="/groups"
          element={<AuthenticationGuard component={Groups} />}
        />
        <Route
          path="/groups/:id"
          element={<AuthenticationGuard component={GroupDetail} />}
        />
        <Route
          path="/collections"
          element={<AuthenticationGuard component={Collections} />}
        />
        <Route
          path="/collections/:id"
          element={<AuthenticationGuard component={CollectionDetail} />}
        />
        <Route
          path="/invites"
          element={<AuthenticationGuard component={MyInvites} />}
        />
        <Route
          path="/admin"
          element={<AuthenticationGuard component={AdminDashboard} />}
        />
        <Route
          path="/admin/users/:userId"
          element={<AuthenticationGuard component={AdminUserDetail} />}
        />
        <Route
          path="*"
          element={<Error message="Error 404 - Page not found." />}
        />
      </Routes>
      <Footer />
    </QueryClientProvider>
  );
}

export default App;
